module.exports = __webpack_public_path__ + "static/img/two-blue.0dcfc794.png";